(ns teamoesterreich.admin-mode.lebensretter.lr-user.modal.clearance-modal
  (:require [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.lr-clearance :as d-lrClearance]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.data.userDocument :as d-userDocument]
            [teamoesterreich.admin-mode.lebensretter.detail.region-part :as region-part]
            [teamoesterreich.element.backend-file :as backend-file]
            [teamoesterreich.text.get-text :as txt]         ;;(h/event-value e)
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as vstate]))


(defn parse-date [date]
  ;(log/debug "parse date" date)
  (js/Date.parse (if date (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)) "1970")))

(defn date-conv [date]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  ;(log/debug "date-conv " date)
  (let [d (js/Date. (if (and (not (nil? date)) (> (count (str date)) 12)) (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)) "1970"))
        y (.getFullYear d)
        m (inc (.getMonth d))
        m (if (> m 9) m (str "0" m))
        d (.getDate d)
        d (if (> d 9) d (str "0" d))]
    (str y "-" m "-" d))
  )
(defn date-conv-back [dateTime]
  ;2021-06-20T23:24 -> 20180701T100000.000Z
  (str (subs dateTime 0 4) (subs dateTime 5 7) (subs dateTime 8 10) "T" "120000.000Z"))

(defn date-ger [date]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count date) 12)
    (str (subs date 6 8) "." (subs date 4 6) "." (subs date 0 4)
         )
    ""
    ))



(defn createEdit-modal [!actual-user !show !edit-running-clearance]
  (let [!loaded (r/cursor vstate/app-state [:lr-list :loaded])
        clearance (d-user/get-active-clearance @!actual-user)
        active-clearance (:lrClearance-valid clearance)
        region_ (select-keys (reduce (fn [c e] (assoc c e true)) {} (clojure.string/split (or (:lrClearance-lrRegionHack clearance)  "|T|K|St|B|V|O|N|all|Sb|W")#"\|")) (txt/txt :fake :lr-regions))
        regionFr_ (select-keys (reduce (fn [c e] (assoc c e true)) {} (clojure.string/split (:lrClearance-frRegionHack clearance) #"\|")) (txt/txt :fake :fr-regions))
        selfExplain-doc (:lrClearance-selfExplainDocument clearance)
        {:keys [user-lastName user-firstName]} @!actual-user
        !st (r/atom {:changed?         false
                     :region           region_
                     :regionFr         regionFr_
                     :lrClearance-end  (max (:lrClearance-end clearance) (:userDocument-validTo selfExplain-doc))
                     :lrClearance-type (or (:lrClearance-type clearance) "EH")
                     })

        selfDeclaration-ok? (:userDocument-isSelfExplain (:lrClearance-selfExplainDocument clearance))
        identity-ok? (:userDocument-isIdentity (:lrClearance-identityDocument clearance))

        handy-validated? (:user-hdyValid @!actual-user)
        email-validated? (:user-emailValid @!actual-user)

        ]
    (fn []
      (log/debug "actual-user-clearance" (clj->js active-clearance))
      (let [!region (r/cursor !st [:region])
            !regionFr (r/cursor !st [:regionFr])
            region-ok? (not-empty @!region)
            date-to-ok? (< (.getTime (new js/Date)) (parse-date (or (:lrClearance-end @!st) (:userDocument-validTo selfExplain-doc))))]
        [mui/modal
         {:className        "clearance-modal"
          :data-clearance   active-clearance
          :aria-labelledby  "simple-modal-title"
          :aria-describedby "simple-modal-description"
          :style            {:display        "flex"
                             :marginRight    "auto"
                             :marginLeft     "auto"
                             :alignItems     "center"
                             :justifyContent "center"}
          :open             (or @!show false)

          }


         [:div
          {
           :class "modal"
           :style {:width 760}}
          [mui/grid {:container  true
                     :direction  "row"
                     :justify    "space-between"
                     :alignItems "flex-start"}
           [mui/grid {:container false :item true :xs 9}
            [:h2 "Lebensretter Freigabe für `" user-firstName " " user-lastName "`!"]
            [:h4 "Selbsterklärung " (:userDocument-selfExplainVersion selfExplain-doc) [:br]
             [:span {:style {:color "blue"}} (:userDocument-fileName selfExplain-doc)] [:br]
             "gültig bis : " (date-ger (:userDocument-validTo selfExplain-doc))]

            ]
           [mui/grid {:container false :item true :xs 3}
            [backend-file/img {:hash             (:userDocument-path selfExplain-doc)
                                      :preview? true
                                      :style    {:position "relative" :float "right" :width "100%" :maxWidth "160px" :maxHeight "260px" :objectFit "contain"} :alt "Ansicht"}]
            ]

           [mui/grid {:container false :item true :xs 6 :style {:background-color (if (not= (:lrClearance-type @!st) (:lrClearance-type clearance)) "#ffd6d2" "#ffffff")}}
            [mui/form-label {:style {:font-size "12px"}} "Qualifiziert durch"
             [mui/select
              {
               :style     {:font-size "16px" :margin-top "4px"}
               :fullWidth true
               :onChange  (fn [e v] (log/debug "type change " (h/event-value e)) (swap! !st assoc :lrClearance-type (h/event-value e)))
               :value     (str "" (:lrClearance-type @!st))
               }
              (for [[k n] (sort-by second (txt/txt :fake :lr-types))]
                ^{:key (str "type-" k)}
                [mui/menu-item {:value k} n])
              ]]
            ]
           [mui/grid {:container false :item true
                      :xs        6
                      :style     {}}

            [mui/text-field {
                             :style        {:background-color (if (not= (:lrClearance-end @!st) (:lrClearance-end clearance)) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :type         "date"
                             :error        (if date-to-ok? false true)
                             :helperText   (if-not date-to-ok? "`Gültig bis` < Jetzt " " ")
                             :onChange     (fn [e] (swap! !st assoc :lrClearance-end (date-conv-back (h/event-value e))))
                             :label        (str "Gültig bis ")
                             :defaultValue (date-conv (:lrClearance-end @!st))
                             }]]

           [mui/grid {:container false :item true :xs 12}
            [region-part/region-form-lr !region region_]
            ]
           (when (not (empty? (txt/txt :fake :fr-regions)))
             [mui/grid {:container false :item true :xs 12}
              (if (d-rights/allow-admin-for d-rights/FIRST_RESPONDER (:user-orgId @!actual-user))
                [region-part/region-form-fr !regionFr regionFr_]
                [region-part/fr-region-view clearance]
                )
              ])

           [mui/grid {:container false :item true :xs 12} [:div]]




           [mui/grid {:container false :item true :xs 6}
            [mui/button
             {:variant   "contained"
              :startIcon (r/as-element [keyboard-arrow-left])
              :style     {:marginRight 50}
              :onClick   (fn []
                           (reset! !show false)
                           (reset! !edit-running-clearance false))
              }
             "Abbrechen"]]

           [mui/grid {:container false :item true :xs 6}
            (log/debug "show button: " (not= "" (str (:lrClearance-type @!st))) selfDeclaration-ok? date-to-ok? region-ok?)
            (if (or (and
                      (not= "" (str (:lrClearance-type @!st)))
                      selfDeclaration-ok? region-ok?
                      ))
              (if active-clearance
                [mui/button
                 {:color     "primary"
                  :style     {:float "right"}
                  :variant   "contained"
                  :startIcon (r/as-element [save])
                  :onClick   (fn [] (d-lrClearance/>edit-clearance (:lrClearance-uuid clearance)
                                                                   {:lrClearance-type         (:lrClearance-type @!st)
                                                                    :lrClearance-end          (:lrClearance-end @!st)
                                                                    :lrClearance-lrRegionHack (reduce (fn [c [k v]] (if v (str c "|" k) c)) "" @!region)
                                                                    :lrClearance-frRegionHack (reduce (fn [c [k v]] (if v (str c "|" k) c)) "" @!regionFr)}
                                                                   (fn [_]
                                                                     (d-user/actual-user-invalidate !actual-user)
                                                                     (reset! !loaded nil)
                                                                     (reset! !show false)
                                                                     )))}
                 "Verändern"]
                [mui/button
                 {:color     "primary"
                  :style     {:float "right"}
                  :variant   "contained"
                  :startIcon (r/as-element [save])
                  :onClick   (fn [] (d-lrClearance/>user-add-edit-clearance (:user-uuid @!actual-user)
                                                                            (merge {:lrClearance-type         (or (:lrClearance-type @!st) "EH")
                                                                                    :lrClearance-end          (or (:lrClearance-end @!st) (:userDocument-validTo selfExplain-doc))
                                                                                    :lrClearance-lrRegionHack (reduce (fn [c [k v]] (if v (str c "|" k) c)) "" @!region)
                                                                                    :lrClearance-frRegionHack (reduce (fn [c [k v]] (if v (str c "|" k) c)) "" @!regionFr)
                                                                                    }
                                                                                   )
                                                                            (fn [_]
                                                                              (d-lrClearance/>validate-clearance (:lrClearance-uuid clearance)
                                                                                                                 {:lrClearance-valid true}
                                                                                                                 (fn [_]
                                                                                                                   (d-user/actual-user-invalidate !actual-user)
                                                                                                                   (reset! !loaded nil)
                                                                                                                   (reset! !show false)
                                                                                                                   )))
                                                                            ))
                  }
                 "Bestätigen"]
                )
              [:span
               (when (= "" (str (:lrClearance-type @!st))) [mui/chip {:color "primary" :label "Qualifiziert durch fehlt"}])
               (when-not identity-ok? [mui/chip {:color "primary" :label "Identitätsnachweis fehlt"}])
               (when-not selfDeclaration-ok? [mui/chip {:color "primary" :label "Selbsterklärung fehlt"}])
               (when-not region-ok? [mui/chip {:color "primary" :label "Regionen nicht gewählt"}])
               (when-not handy-validated? [mui/chip {:color "primary" :label "Mobilnummer nicht validiert"}])
               (when-not email-validated? [mui/chip {:color "primary" :label "Email nicht validiert"}])
               ;(when-not (:user-profileValid @!actual-user) [mui/chip {:color "primary" :label "Profil nicht vollständig"}])

               ])]
           ]]]
        ))))


(defn view-modal [!edit-running-clearance !actual-user !show]
  (let [lrClearance (:user-lrClearance @!actual-user)
        {:keys [user-lastName user-firstName]} @!actual-user
        training-doc (:lrClearance-trainingDocument lrClearance)
        ]
    (fn []
      (let []
        (js/console.log "active-lrClearance " (clj->js lrClearance))
        [mui/modal
         {:className        "clearance-load-modal"
          :aria-labelledby  "simple-modal-title"
          :aria-describedby "simple-modal-description"
          :style            {:display        "flex"
                             :marginRight    "auto"
                             :marginLeft     "auto"
                             :alignItems     "center"
                             :justifyContent "center"}
          :open             (or @!show false)
          }


         [:div
          {
           :class "modal"
           :style {:width 750}}
          [mui/grid {:container  true
                     :direction  "row"
                     :justify    "space-between"
                     :alignItems "flex-start"}
           [mui/grid {:container false :item true :xs 12}
            [:h2 "Lebensretter Freigabe für `" user-firstName " " user-lastName "`!"]

            ]

           [mui/grid {:container false :item true :xs 12}
            [:div
             "Qualifiziert durch " [:span {:style {:color "#ff0000"}} (or (get (txt/txt :fake :lr-types) (:lrClearance-type lrClearance)) (:lrClearance-type lrClearance))]]]

           [mui/grid {:container false :item true :xs 12}
            [:div
             "Von " [:span (date-ger (:lrClearance-start lrClearance))]
             " bis "
             [:span (date-ger (:lrClearance-end lrClearance))]
             ]
            ]

           [mui/grid {:container false :item true :xs 12}
            "Regionen: "
            [region-part/region-view lrClearance]
            ]

           (when (not (empty? (txt/txt :fake :fr-regions)))
             [mui/grid {:container false :item true :xs 12}
              "First Responder Regionen: "
              [region-part/fr-region-view (txt/txt :fake :fr-regions)]
              ])

           [mui/grid {:container false :item true :xs 12} [:div {:style {:height "10px"}}]]

           [mui/grid {:container false :item true :xs 6}
            [mui/button
             {:variant   "contained"
              :startIcon (r/as-element [keyboard-arrow-left])
              :style     {:marginRight 50}
              :onClick   #(reset! !show false)
              }
             "Schließen"]]

           [mui/grid {:container false :item true :xs 6}


            [mui/button
             {:color     "primary"
              :style     {:float "right"}
              :variant   "contained"
              :startIcon (r/as-element [save])
              :onClick   #(reset! !edit-running-clearance true)
              }
             "Verändern"]
            ]
           ]]]
        ))))





(defn get-user-details [!actual-user tomId]
  (d-user/get-user-all tomId
                       (fn [data]
                         (reset! !actual-user data)))
  )

(defn modal-by-tomId [!tomId]
  (let [!actual-user (r/atom {})
        !actual-wop-uuid (r/atom {})
        !st (r/atom {:edit-running-clearance false})
        !edit-running-clearance (r/cursor !st [:edit-running-clearance])]
    (fn []
      (when (pos? @!tomId)
        (let [user @!actual-user
              tomId @!tomId
              wop-clearance (:user-lrClearance @!actual-user)
              active-clearance (:lrClearance-valid wop-clearance)

              wop-identity-document (:lrClearance-identityDocument wop-clearance)
              proposed-identity-document (or wop-identity-document (first (filter (fn [{active :userDocument-active isIdentity :userDocument-isIdentity}] (and active isIdentity)) (:user-userDocument @!actual-user))))

              wop-selfDeclaration-document (:lrClearance-selfExplainDocument wop-clearance)
              proposed-selfDeclaration-document (or wop-selfDeclaration-document (first (filter (fn [{active :userDocument-active isSelfExplain :userDocument-isSelfExplain}] (and active isSelfExplain)) (:user-userDocument @!actual-user))))

              wop-training-document (:lrClearance-trainingDocument wop-clearance)
              proposed-training-document (or wop-training-document (first (filter (fn [{active :userDocument-active isTraining :userDocument-isTraining}] (and active isTraining)) (:user-userDocument @!actual-user))))

              ]
          (log/debug "render clearance modal-by-tomId " tomId (clj->js proposed-identity-document) (clj->js proposed-selfDeclaration-document) (clj->js proposed-training-document))
          (when (not= tomId (:reqTomId user))
            (get-user-details !actual-user tomId))


          (println "getUpdate WOP" @!tomId "!=" (:reqTomId user))
          (log/debug "getUpdate WOP" @!tomId "!=" (:reqTomId user))

          (if (or (not= @!tomId (:reqTomId user))
                  (:error user))
            ;no data
            [mui/modal
             {:aria-labelledby  "simple-modal-title"
              :aria-describedby "simple-modal-description"
              :style            {:display        "flex"
                                 :marginRight    "auto"
                                 :marginLeft     "auto"
                                 :alignItems     "center"
                                 :justifyContent "center"}
              :open             (pos? tomId)
              :onClose          (fn []
                                  (reset! !actual-user {})
                                  (reset! !tomId nil))
              }
             [:div
              {:class "modal"
               :style {:width 400}}

              [:h4 (str "Freigabe bestätigen: " tomId)]
              [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
              [mui/typography "Lade den Datensatz ... "]
              [mui/typography {:color "primary"} (:error user)]
              [:br]
              [mui/button
               {:color   "primary"
                :variant "contained"
                :onClick (fn []
                           (reset! !actual-user {})
                           (reset! !tomId {}))
                }
               "Schließen"]
              ]]
            ;has data
            (cond
              (and active-clearance @!edit-running-clearance) [(createEdit-modal !actual-user !tomId !edit-running-clearance)]
              active-clearance [(view-modal !edit-running-clearance !actual-user !tomId)]
              wop-clearance [(createEdit-modal !actual-user !tomId !edit-running-clearance)]
              :else nil
              )))))))

